import { rem } from "@certn/cascadia";
import { css } from "@emotion/css";

export function useSettingsDropdownStyles() {
  return {
    container: css({
      display: "flex",
      flexDirection: "column",
      gap: rem("space-1"),
    }),
    section: css({
      padding: rem("space-1"),
      display: "flex",
      flexDirection: "column",
      gap: rem("space-1"),
      width: "100%",
      boxSizing: "border-box",
    }),
    divider: css({
      margin: `${rem("space-1")} ${rem("space-0")}`,
    }),
    nameSection: css({
      display: "flex",
      flexDirection: "column",
      gap: rem("space-05"),
      padding: `${rem("space-4")} ${rem("space-3")}`,
      width: "100%",
      boxSizing: "border-box",
    }),
    linkItem: css({
      padding: `${rem("space-2")} ${rem("space-3")}`,
      width: "100%",
      boxSizing: "border-box",
      cursor: "pointer",
      borderRadius: rem("space-1"),
      textDecoration: "none",
      border: "none",
      textAlign: "start",
      background: "none",
    }),
  };
}
